import isArray from 'lodash/isArray';

export const setImmutable = (obj, path, value) => {
  const keys = isArray(path) ? [...path] : path.split('.');
  const newObj = isArray(obj) ? [...obj] : {...obj};
  let current = newObj;
  do {
    const key = keys.shift();
    if (keys.length) {
      current[key] = isArray(current[key]) ? [...current[key]] : {...current[key]};
      current = current[key];
    } else {
      current[key] = value;
    }
  } while (keys.length);
  return newObj;
};
